import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Alert, Col, Row, FormGroup, ControlLabel } from 'react-bootstrap';
import { Icon, NameFields } from '../../../../common/components';
import DatePickerDob2 from '../../../../common/components/DatePicker/DatePickerDob2';
import { AddressFields } from '../../../../common/components/ReduxFormField';
import PostcodeList from '../../../../common/components/Postcode/PostcodeList';
import 'moment/locale/en-gb';
import { get } from 'lodash';
import './styles.scss';
import { SimpleHorizontalFormControl } from '../../../../common/simpleComponents';
import { toastr } from 'react-redux-toastr';

const travellerDefaults = {
  title: '',
  first_name: '',
  last_name: '',
  dob: '',
  email: '',
  phone1: '',
  phone2: '',
  conditions_covered: true,
  screening: '',
  screening_id: '',
};

export default class TravellersAddress extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    formValues: PropTypes.array,
    travellerGroup: PropTypes.string,
    displayGroups: PropTypes.array,
    child: PropTypes.bool,
    label: PropTypes.string,
    buttonLabel: PropTypes.string,
    leadAddress: PropTypes.bool,
    leadContact: PropTypes.bool,
    change: PropTypes.func,
    noTravellers: PropTypes.object,
    dobReadOnly: PropTypes.bool,
    postCodeReviewError: PropTypes.bool,
    postCodeReviewMessage: PropTypes.string,
  };

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(props) {
    const { fields, formValues, travellerGroup, child } = props;
    if (travellerGroup !== this.props.travellerGroup) {
      fields.removeAll();

      if (!child) {
        fields.push(formValues ? formValues[0] : travellerDefaults);

        if (travellerGroup === 'couple') {
          fields.push(
            formValues && formValues.length >= 2 ? formValues[1] : travellerDefaults,
          );
        } else if (travellerGroup === 'family') {
          if (formValues && formValues.length >= 2) {
            fields.push(formValues[1]);
          }
        } else if (travellerGroup === 'group') {
          if (formValues && formValues.length > 0) {
            formValues.forEach((formValue, i) => {
              if (i > 0) fields.push(formValue);
            });
          } else {
            for (let i = 0; i < 4; i++) {
              fields.push(travellerDefaults);
            }
          }
        }
      } else {
        if (travellerGroup === 'family') {
          if (formValues && formValues.length > 0) {
            fields.push(formValues ? formValues[0] : travellerDefaults);
            formValues.forEach((formValue, i) => {
              if (i > 0) fields.push(formValue);
            });
          }
        }
      }
    }
  }

  render() {
    const {
      disableAddressFields,
      fields,
      leadAddress,
      formValues,
      child,
      label,
      disableAgeField,
      travellerGroup,
      displayGroups,
      goTab01,
      loggedInUserEmail,
    } = this.props;

    // Hide if only set to display for specific groups
    if (displayGroups && displayGroups.indexOf(travellerGroup) === -1) {
      return <div />;
    }

    const leadTravellerEmail =  formValues?.[0]?.email ?? '';

    if (leadTravellerEmail && leadTravellerEmail === loggedInUserEmail) {
      toastr.error(
        'Invalid email address',
        "Please do not use your own email address. Enter your customer's email address" +
          ' or leave blank. Please note if your customer takes Smart Luggage they will ' +
          'need an email address.',
        { timeOut: 15000 },
      );
    }

    return (
      <div className="travellers">
        {fields.map((insured, index) => {
          return (
            <div
              key={index}
              className={
                'traveller-row-address  traveller' + index + (child ? ' child' : '')
              }
            >
              {!index && !child && !label ? (
                <Row>
                  <Col sm={12}>
                    <h4>
                      <strong>Lead Traveller</strong>
                    </h4>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col sm={12}>
                    <span
                      className="remove-traveller pull-right"
                      onClick={() => fields.remove(index)}
                    >
                      <Icon name="times" />
                    </span>
                    <h4>
                      {label ? label : child ? 'Child' : 'Adult'} {index + 1}
                    </h4>
                  </Col>
                </Row>
              )}

              <NameFields
                baseName={insured}
                label="Name"
                labelSize={2}
                fieldSize={6}
                disableOnBlur
                fieldComponent={Field}
                child={child}
              />

              <FormGroup>
                <Col sm={2}>
                  <ControlLabel>Date of birth</ControlLabel>
                </Col>
                <Col sm={3}>
                  <Field
                    name={insured + '.dob'}
                    label="Date of birth"
                    simple
                    messageType={'Alert'}
                    goTab01={goTab01}
                    component={DatePickerDob2}
                    labelSize={6}
                  />
                </Col>
                <Col sm={1}>
                  <ControlLabel>Age</ControlLabel>
                </Col>
                <Col sm={2}>
                  <Field
                    name={insured + '.age'}
                    disabled={disableAgeField}
                    component={SimpleHorizontalFormControl}
                  />
                </Col>
              </FormGroup>

              {/*<div className='col-xs-4 text-align-center' style={{ padding: '0' }}>*/}
              {/*{index && !hideSurnameQuestion ? renderSurnameQuestion(insured) : null}*/}
              {/*</div>*/}

              {!child && !index && (
                <div>
                  <FormGroup>
                    <Col sm={2}>
                      <ControlLabel>Email address of lead traveller</ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <Field
                        name={insured + '.email'}
                        type="email"
                        placeholder="Optional - enter customer email address"
                        displayAlert
                        component={SimpleHorizontalFormControl}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={2}>
                      <ControlLabel>Telephone</ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <Field
                        name={insured + '.phone1'}
                        placeholder="Optional"
                        component={SimpleHorizontalFormControl}
                      />
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Col sm={2}>
                      <ControlLabel>Mobile</ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <Field
                        name={insured + '.phone2'}
                        placeholder="Optional"
                        component={SimpleHorizontalFormControl}
                      />
                    </Col>
                  </FormGroup>
                </div>
              )}

              {!index && leadAddress && (
                <div>
                  <Row>
                    <Col sm={8}>
                      <PostcodeList
                        name={insured + '.address.postcode'}
                        label="Postcode"
                        //disabled
                        formName={'LeisureTravelForm'}
                        labelSize={3}
                        postcodeFieldSize={6}
                        smFieldSize={9}
                        value={get(formValues, '[' + index + '].address.postcode', '')}
                        targetField={insured + '.address'}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={5} smOffset={2}>
                      {this.props.postCodeReviewError ? (
                        <Alert bsStyle="danger">{this.props.postCodeReviewMessage}</Alert>
                      ) : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={8}>
                      <AddressFields
                        disabled={disableAddressFields}
                        baseName={insured + 'address'}
                        label="Address"
                        labelSize={3}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}
